import { render, staticRenderFns } from "./BuildQuestionGroups.vue?vue&type=template&id=9e0abc3a"
import script from "./BuildQuestionGroups.vue?vue&type=script&lang=js"
export * from "./BuildQuestionGroups.vue?vue&type=script&lang=js"
import style0 from "./BuildQuestionGroups.vue?vue&type=style&index=0&id=9e0abc3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports